import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import StaticExportFileSpecLookup from '../Models/Lookups/StaticExportFileSpecLookup';
import { ModalUtils, Validation } from '@singularsystems/neo-core';
import { TextConstants } from '../../../Common/TextConstants';
import GetExportFileSpecDateOverlapQuery from '../Models/Queries/GetExportFileSpecDateOverlapQuery';


export default class ManageExportFileSpecVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public staticExportFileSpecApiClient = AppService.get(Types.ApiClients.StaticExportFileSpecApiClient),
        public checkQueryApiClient = AppService.get(Types.ApiClients.CheckQueryApiClient),
        public exportFileSpecApiClient = AppService.get(Types.ApiClients.StaticExportFileSpecApiClient),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {

        super(taskRunner);
        this.makeObservable();
    }

    public managedExportFileSpecLookupModel = new StaticExportFileSpecLookup();
    public showManageExportFileSpecComponent: boolean = false;
    public getExportFileSpecDateOverlapQuery = new GetExportFileSpecDateOverlapQuery();
    
    public isFieldReadonlyInd: boolean = false;
    public updateExportFileSpecReadOnlyInd: boolean = false;
    public activeEndDateIsNull: boolean = false;
    public confirmSaveInd: boolean = false;
    public showConfirmSaveComponent: boolean = false;
    public showConfirmSaveNewComponent: boolean = false;
    public exportFileSpecDatesOverlapWithAnotherVersionInd: boolean = false;

    public validationModeDisplay = Validation.DisplayMode.AfterSubmit;


    public async initialise() {
        this.managedExportFileSpecLookupModel = new StaticExportFileSpecLookup();
    }

    public toggleActiveEndDateSetToNull() {
        this.activeEndDateIsNull = !this.activeEndDateIsNull;
    }

    public closeConfirmationModal() {
        this.showConfirmSaveComponent = false;
    }

    public closeConfirmationNewModal() {
        this.showConfirmSaveNewComponent = false;
    }
    public showConfirmSaveModal() {
        if (!this.isValid) {
            ModalUtils.showMessage(TextConstants.Titles.Error, TextConstants.Notifications.MissingRequiredFields);
            this.validationModeDisplay = Validation.DisplayMode.Always;
        }
        else {
            this.confirmSaveInd = true;
            this.showConfirmSaveComponent = true;
        }
    }

    public confirmSave() {
        this.confirmSaveInd = true;
        this.closeConfirmationModal();
    }
}